import type { CatalogEntry } from '../catalog';

/**
 * A first-class widget idea: a catalog entry plus what the person needs to judge
 * it - the shape it reads best at, what it binds, and a demo placement.
 */
export interface IdeaEntry extends CatalogEntry {
  /** Grid columns × rows the widget reads best at. */
  aspect: string;
  /** For the person: what it binds to and what the JS computes. */
  about: string;
  /**
   * How the seed script places it on the Widget Ideas board. Symbol fields hold
   * `$name` placeholders resolved against the dev box: `$cpu`, `$load1`, `$load5`,
   * `$ramUsed`, `$ramAvail`, `$core1`..`$core8`; `controllerId` is always `$ctrl`.
   */
  demo?: { config: Record<string, unknown>; w: number; h: number };
}

/** A demo symbol binding, spelled once. */
export const bind = (name: string, label: string, extra: Record<string, unknown> = {}) =>
  ({ controllerId: '$ctrl', symbolId: `$${name}`, label, ...extra });
